import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import type { AdminDashboard } from '@shared/schemas/dashboard';

/**
 * The admin dashboard — ROADMAP.md §10.6.
 *
 * **One query for the whole screen.** Nine things, one request: a dashboard
 * assembled from nine hooks is the shape `request-budget.spec.ts` exists to
 * catch, and this is the first screen opened each morning so it gets one wait
 * rather than nine.
 */
export function useDashboard() {
  return useQuery({
    queryKey: ['admin', 'dashboard'],
    queryFn: () => api.get<AdminDashboard>('/api/admin/dashboard'),
  });
}
